// extracted by mini-css-extract-plugin
export default {"details":"details_details__FSoHH","question":"details_question__x4SRa","sub_question":"details_sub_question__gzEts","wrapper":"details_wrapper__8kywP"};